export default {
    page_title: "Kevi | Email Marketing Report",
    title: "Email Marketing Report",
    stats: {
        total_sent: "Emails Sent",
        delivered: "Delivered",
        opened: "Opened",
        clicked: "Clicks",
        failed: "Failed",
        total_orders: "Converted Orders",
        total_reactivated_orders: "Reactivated Orders",
        total_revenue: "Incentivized Revenue",
    },
    chart: {
        sent: "Sent",
        delivered: "Delivered",
        opened: "Opened",
        clicked: "Clicks",
    },
    table: {
        title: "Performance by Automation",
        automation: "Automation",
        sent: "Sent",
        delivered: "Delivered",
        opened: "Opened",
        clicked: "Clicks",
        replies: "Replies",
        open_rate: "Open Rate",
        click_rate: "Click Rate",
        orders_count: "Converted Orders",
        reactivated_orders_count: "Reactivated Orders",
        revenue: "Incentivized Revenue",
        export_csv: "Export CSV",
        exporting: "Exporting...",
        export_filename: "email-automations-report",
    },
    filters: {
        status_label: "Status",
        automation_label: "Automation",
        status_accepted: "Accepted",
        status_scheduled: "Scheduled",
        status_sent: "Sent",
        status_failed: "Failed",
    },
    empty: {
        no_emails_message: "You haven't sent any emails in this period",
        create_automation: "Create Automation",
        no_tracking_message: "Talk to our support to enable click and open tracking on your email sender",
        no_data_period: "There is not enough data for the selected period",
    },
};
